import React from 'react';

export default function Hs() {
  return (
    <a 
      href="https://www.hindsight.vision" 
      target="_blank" 
      rel="noopener noreferrer" 
      style={{ float: 'right', color: '#f5c06c' }}
      title="Powered by Hindsight Visions"
    >
      <img 
        src="/scope2.png" 
        alt="Powered by Hindsight Visions" 
        style={{ height: '24px', verticalAlign: 'middle' }} 
      />
    </a>
  );
}
